var React = require('react');

function Locations (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4 16.4541C4 7.36675 11.3668 0 20.4541 0C29.5415 0 36.9083 7.36675 36.9083 16.4541C36.9083 18.368 36.2426 20.4556 35.2855 22.4992C34.319 24.5631 33.0011 26.6936 31.5782 28.7228C28.7314 32.7822 25.3831 36.5501 23.3417 38.7379C21.7713 40.4207 19.1373 40.4207 17.5668 38.7379C15.5253 36.5504 12.177 32.7824 9.33036 28.7228C7.90747 26.6936 6.58957 24.5631 5.62301 22.4992C4.66592 20.4556 4.00024 18.3679 4.00024 16.4541H4ZM12.2271 15.083C12.2271 10.5394 15.9106 6.85589 20.4541 6.85589C24.9977 6.85589 28.6812 10.5394 28.6812 15.083C28.6812 19.6265 24.9977 23.31 20.4541 23.31C15.9106 23.31 12.2271 19.6265 12.2271 15.083Z"}));
}

Locations.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"currentColor"};

module.exports = Locations;

Locations.default = Locations;
